module.exports = __webpack_public_path__ + "img/star.044a788d.svg";